import { render, staticRenderFns } from "./GroupMealsShiftsChart.vue?vue&type=template&id=f5a32be2"
import script from "./GroupMealsShiftsChart.vue?vue&type=script&lang=js"
export * from "./GroupMealsShiftsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports